import { render, staticRenderFns } from "./yearlyInflationRates.vue?vue&type=template&id=4606ae86"
import script from "./yearlyInflationRates.vue?vue&type=script&lang=js"
export * from "./yearlyInflationRates.vue?vue&type=script&lang=js"
import style0 from "./yearlyInflationRates.vue?vue&type=style&index=0&id=4606ae86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports